import { AppShellLayout } from "@civala/shared-ui"
import { useLocation, useNavigate } from "@tanstack/react-router"
import type { ReactNode } from "react"

import { NAV_SECTIONS } from "@/lib/navigation"

import { InvestorTopBarLeft, InvestorTopBarRight } from "./InvestorTopBar"

type InvestorShellProps = {
  readonly children: ReactNode
}

export function InvestorShell({ children }: InvestorShellProps) {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <AppShellLayout
      persistKey="investor"
      sidebarSections={NAV_SECTIONS}
      activePath={location.pathname}
      onNavigate={(path) => void navigate({ to: path })}
      brand={{ subtitle: "Investor" }}
      topBar={{
        left: <InvestorTopBarLeft />,
        right: <InvestorTopBarRight />,
      }}
      viewTransitionName="investor-content"
    >
      {children}
    </AppShellLayout>
  )
}
